import { render, staticRenderFns } from "./RecordStudentScore.vue?vue&type=template&id=e534d33a&scoped=true"
import script from "./RecordStudentScore.vue?vue&type=script&lang=js"
export * from "./RecordStudentScore.vue?vue&type=script&lang=js"
import style0 from "./RecordStudentScore.vue?vue&type=style&index=0&id=e534d33a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e534d33a",
  null
  
)

export default component.exports